// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__jWNL5","headerCell":"Cell_headerCell__L0by5","resizerHandle":"Cell_resizerHandle__AMyI9"};